<template>
    <v-layout>
        <v-flex xs12 sm6 offset-sm3 class="elevation-24">
            <v-card color="rgba(0,0,0,.75)">
                <v-card-title style="text-align: center; margin-top:20vh;">
                    <div style="margin: auto;color:orange;" class="display-4">🛠</div><br>
                    <span class="display-3 white--text">Die Seite konnte leider nicht gefunden werden. </span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="deep-orange" to="/">Gehe zur Home Seite</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style>

</style>